var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VPopover',{attrs:{"trigger":"hover click focus"}},[_vm._t("trigger"),_vm._t("popover",null,{"slot":"popover"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }